import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Centered } from '../../layout/Centered';
import { captureException } from '../../sentry';

export const SomethingWentWrong = ({ height }: { height?: number }) => {
  const { t } = useTranslation();
  return <Centered height={height}>{t('Something went wrong')}</Centered>;
};

/**
 * SomethingWentWrong component that also reports to Sentry.
 * Use this instead of SomethingWentWrong when you want to track the error.
 */
export const SomethingWentWrongWithReport = ({
  height,
  error,
  context
}: {
  height?: number;
  error?: unknown;
  context?: Record<string, unknown>;
}) => {
  useEffect(() => {
    captureException(
      error instanceof Error
        ? error
        : new Error('SomethingWentWrong rendered: ' + (error || 'unknown')),
      {
        tags: { feature: 'something_went_wrong_fallback' },
        extra: context,
        level: 'error'
      }
    );
  }, [error, context]);

  return <SomethingWentWrong height={height} />;
};
